/**
 * Fetch suppliers list based on the search input
 * @param {string} searchString - The search query string
 * @param {Object} authAxios - Authenticated axios instance
 * @returns {Promise<Array<{
 *   supplierNumber: string;
 *   supplierName: string;
 *   supplierNameLine2: string;
 *   supplierType: string;
 *   activeSupplierType: string;
 *   physicalAddress: string;
 *   physicalAddress2: string;
 *   city: string;
 *   state: string;
 *   postalCode: string;
 *   country: string;
 *   districtCode: string;
 * }>} Array of supplier objects
 */
export async function fetchSuppliersList(authAxios, searchString) {
    try {
        const response = await authAxios.get(`/suppliers?queryString=${searchString}`);
        return response.data;
    } catch (e) {
        console.error("Error fetching suppliers:", e);
        throw e;
    }
}
